import { Box, Link, Grid } from '@mui/material';
import columnarLinkedList from '@/utils/columnarLinkedList';
import { useResponsive } from '@/components/hooks/useResponsive';

interface ColumnarLinkedListProps {
  items: { name: string; link: string }[];
  desktopItemsPerColumn?: number;
  tabletItemsPerColumn?: number;
}

export const ColumnarLinkedList = ({
  items,
  desktopItemsPerColumn = 11,
  tabletItemsPerColumn = 13,
}: ColumnarLinkedListProps) => {
  const { isMediumViewport, isLargeViewport } = useResponsive();

  const itemListLength = items.length;
  const numItemsPerColumn = (() => {
    if (isLargeViewport) return desktopItemsPerColumn;
    if (isMediumViewport) return tabletItemsPerColumn;
    if (itemListLength / 2 <= 22) {
      return itemListLength;
    }
    return Math.ceil(itemListLength / 2);
  })();

  const itemColumns = columnarLinkedList(items, numItemsPerColumn);

  return (
    <Grid container columnSpacing={{ sm: 6, md: 8 }}>
      {itemColumns.map((itemColumn, columnIndex) => (
        <Grid
          key={`col-${columnIndex + 1}`}
          item
          sx={{
            paddingRight: { xs: 3, sm: 3, md: 0 },
            listStyle: 'none',
            minWidth: { md: '250px' },
          }}>
          <Box component="ul" m={0} p={0} sx={{ listStyle: 'none' }}>
            {itemColumn.map((item, itemIndex) => (
              <Box key={`item-${columnIndex + 1}-${itemIndex + 1}`} component="li" mb={2}>
                <Link
                  variant="link2"
                  href={item.link}
                  sx={{
                    textDecoration: 'underline',
                    color: 'text.primary',
                  }}>
                  {item.name}
                </Link>
              </Box>
            ))}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
